const LikeAnimation = {
  mounted() {
    this.wasLiked = this.el.querySelector('[data-liked="true"]') !== null;
  },

  updated() {
    const isNowLiked = this.el.querySelector('[data-liked="true"]') !== null;
    
    // Only animate if state changed from unliked to liked
    if (!this.wasLiked && isNowLiked) {
      const icon = this.el.querySelector('[data-liked="true"]');
      if (icon) {
        // Add animation class
        icon.classList.add('heart-pop');
        
        // Remove it after animation completes
        setTimeout(() => {
          icon.classList.remove('heart-pop');
        }, 500);
      }
    }
    
    // Update state for next update
    this.wasLiked = isNowLiked;
  }
};

export default LikeAnimation;
